import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ n, children, light = false }) => (
  <div className={`flex items-center gap-4 text-xs tracking-[0.3em] uppercase ${light ? "text-[#5b5346]" : "text-[var(--muted)]"}`}>
    <span className="font-display text-[var(--gold-deep)]">{n}</span>
    <span className={`h-px w-12 ${light ? "bg-[#0A0D14]/30" : "bg-white/25"}`} />
    <span>{children}</span>
  </div>
);
